import type { OrderType } from "@lib/types/orderType";
import type { EstimatedTime } from "@lib/zod/deliverySchema";

export const estimatedTimeText = (
    currentOrderType: OrderType,
    deliveryZoneEstimatedTime?: EstimatedTime,
    defaultEstimatedDeliveryTime?: EstimatedTime,
    defaultEstimatedPickupTime?: EstimatedTime
) => {
    return estimatedTimeText1(
        currentOrderType,
        getEstimatedTimeJSON(
            currentOrderType,
            deliveryZoneEstimatedTime,
            defaultEstimatedDeliveryTime,
            defaultEstimatedPickupTime)
    );
}

export const getEstimatedTimeJSON = (
    currentOrderType: OrderType,
    deliveryZoneEstimatedTime?: EstimatedTime,
    defaultEstimatedDeliveryTime?: EstimatedTime,
    defaultEstimatedPickupTime?: EstimatedTime
) => {
    return currentOrderType === 'delivery'
        ? (deliveryZoneEstimatedTime ||
            defaultEstimatedDeliveryTime)
        : (defaultEstimatedPickupTime);
}

export const estimatedTimeText1 = (
    currentOrderType: OrderType,
    estimatedTime: EstimatedTime | undefined,
) => {
    if (!estimatedTime) return undefined;
    const times = [
        estimatedTime.min,
        estimatedTime.max
    ].filter(Boolean);
    let timeLabel = 'Estimation';
    if (currentOrderType === 'delivery') {
        timeLabel = 'Estimated Delivery';
    } else if (currentOrderType === 'pickup') {
        timeLabel = 'Estimated Preparation'
    }
    return times.length ? `${timeLabel}: ${times.join('-')} ${estimatedTime.unit || ''}` : undefined;
}